// extracted by mini-css-extract-plugin
export default {"modal":"CreateNewModal_modal__8xAba","selectedFile":"CreateNewModal_selectedFile__XDUNc"};